import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import { AttachmentFieldsFragmentDoc } from '../../../fragments/attachmentFields.generated';
import { ParagraphFieldsFragmentDoc } from '../../../fragments/paragraphFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetRegulationsFormDataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetRegulationsFormDataQuery = { __typename?: 'Query', regulations: Array<{ __typename?: 'Regulation', id: string, name: string }> };

export type GetRegulatoryDocumentsFormDataQueryVariables = Types.Exact<{
  regulationId: Types.Scalars['ID'];
}>;


export type GetRegulatoryDocumentsFormDataQuery = { __typename?: 'Query', regulation?: { __typename?: 'Regulation', id: string, regulatoryDocuments: Array<{ __typename?: 'RegulatoryDocument', id: string, createdAt?: any | null, modifiedAt?: any | null, status: Types.RegulatoryDocumentStatus, name: string, summary?: string | null, modelYear?: number | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, dateEffective?: any | null, dateExpiration?: any | null, document?: { __typename?: 'BlobRef', uri: any } | null, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, vkos: Array<{ __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }> }>, regulation?: { __typename?: 'Regulation', id: string, name: string, regulationNumber: string } | null, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, paragraphs: Array<{ __typename?: 'RegulatoryDocumentParagraph', page: number, createdAt?: any | null, modifiedAt?: any | null, id: string, modelYear?: number | null, comprehensive?: any | null, dateNewRegistration?: any | null, dateNewTypes?: any | null, summary?: string | null, level: number, enumeration: string, isFootnote: boolean, position: number, changeInfoType: Types.ChangeInfoType, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, tags: Array<{ __typename?: 'Tag', id: string, name: string }>, elements: Array<{ __typename?: 'RegulatoryDocumentParagraphElement', type: Types.ParagraphElementType, text?: string | null, isHeader: boolean, page: number, bounds?: Array<number> | null, textPosition?: Types.TextPosition | null, asset?: { __typename?: 'BlobRef', contentType: string, fileName: string, uri: any } | null }>, attachments?: Array<{ __typename?: 'AttachmentRef', attachmentId: string, isVkoOnly?: boolean | null, file: { __typename?: 'BlobRef', uri: any, contentType: string, fileName: string, originalFileName?: string | null }, category?: { __typename?: 'AttachmentCategory', id: string, name: string } | null }> | null, comments?: Array<{ __typename?: 'Commentary', id: string, comment?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, faqs?: Array<{ __typename?: 'Faq', id: string, question?: string | null, answer?: string | null, createdAt?: any | null, modifiedAt?: any | null, createdBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null }, modifiedBy: { __typename?: 'User', givenName?: string | null, id: string, mail?: string | null, name: string, surname?: string | null, userPrincipalName?: string | null } }> | null, driveVariants: Array<{ __typename?: 'DriveVariant', id: string, name: string }>, keywords: Array<{ __typename?: 'Keyword', id: string, name: string, sortPriority?: number | null, descriptions?: Array<{ __typename?: 'TranslationObject', lang: Types.TranslationLang, translation: string }> | null, vexClusters: Array<{ __typename?: 'VexCluster', id: string, name: string }>, vkos: Array<{ __typename?: 'User', id: string, name: string }> }>, vehicleCategories: Array<{ __typename?: 'VehicleCategory', id: string, name: string }>, categories: Array<{ __typename?: 'Category', id: string, name: string }>, phaseIn?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, phaseOut?: Array<{ __typename?: 'PhaseDate', date?: any | null, status?: string | null }> | null, requirements: Array<{ __typename?: 'Requirement', id: string, name: string, requirementId?: string | null }> }> }> } | null };


export const GetRegulationsFormDataDocument = gql`
    query GetRegulationsFormData {
  regulations {
    id
    name
  }
}
    `;

/**
 * __useGetRegulationsFormDataQuery__
 *
 * To run a query within a React component, call `useGetRegulationsFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationsFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationsFormDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegulationsFormDataQuery(baseOptions?: Apollo.QueryHookOptions<GetRegulationsFormDataQuery, GetRegulationsFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulationsFormDataQuery, GetRegulationsFormDataQueryVariables>(GetRegulationsFormDataDocument, options);
      }
export function useGetRegulationsFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationsFormDataQuery, GetRegulationsFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulationsFormDataQuery, GetRegulationsFormDataQueryVariables>(GetRegulationsFormDataDocument, options);
        }
export type GetRegulationsFormDataQueryHookResult = ReturnType<typeof useGetRegulationsFormDataQuery>;
export type GetRegulationsFormDataLazyQueryHookResult = ReturnType<typeof useGetRegulationsFormDataLazyQuery>;
export type GetRegulationsFormDataQueryResult = Apollo.QueryResult<GetRegulationsFormDataQuery, GetRegulationsFormDataQueryVariables>;
export const GetRegulatoryDocumentsFormDataDocument = gql`
    query GetRegulatoryDocumentsFormData($regulationId: ID!) {
  regulation(id: $regulationId) {
    id
    regulatoryDocuments {
      id
      createdAt
      modifiedAt
      status
      name
      summary
      document {
        uri
      }
      keywords {
        id
        name
        vkos {
          givenName
          id
          mail
          name
          surname
          userPrincipalName
        }
      }
      regulation {
        id
        name
        regulationNumber
      }
      modelYear
      dateNewRegistration
      dateNewTypes
      dateEffective
      dateExpiration
      attachments {
        ...AttachmentFields
      }
      paragraphs {
        ...ParagraphFields
      }
    }
  }
}
    ${AttachmentFieldsFragmentDoc}
${ParagraphFieldsFragmentDoc}`;

/**
 * __useGetRegulatoryDocumentsFormDataQuery__
 *
 * To run a query within a React component, call `useGetRegulatoryDocumentsFormDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulatoryDocumentsFormDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulatoryDocumentsFormDataQuery({
 *   variables: {
 *      regulationId: // value for 'regulationId'
 *   },
 * });
 */
export function useGetRegulatoryDocumentsFormDataQuery(baseOptions: Apollo.QueryHookOptions<GetRegulatoryDocumentsFormDataQuery, GetRegulatoryDocumentsFormDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRegulatoryDocumentsFormDataQuery, GetRegulatoryDocumentsFormDataQueryVariables>(GetRegulatoryDocumentsFormDataDocument, options);
      }
export function useGetRegulatoryDocumentsFormDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulatoryDocumentsFormDataQuery, GetRegulatoryDocumentsFormDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRegulatoryDocumentsFormDataQuery, GetRegulatoryDocumentsFormDataQueryVariables>(GetRegulatoryDocumentsFormDataDocument, options);
        }
export type GetRegulatoryDocumentsFormDataQueryHookResult = ReturnType<typeof useGetRegulatoryDocumentsFormDataQuery>;
export type GetRegulatoryDocumentsFormDataLazyQueryHookResult = ReturnType<typeof useGetRegulatoryDocumentsFormDataLazyQuery>;
export type GetRegulatoryDocumentsFormDataQueryResult = Apollo.QueryResult<GetRegulatoryDocumentsFormDataQuery, GetRegulatoryDocumentsFormDataQueryVariables>;